import { render } from "./ClaimAssetImage.vue?vue&type=template&id=28fd4b69&scoped=true"
import script from "./ClaimAssetImage.vue?vue&type=script&lang=js"
export * from "./ClaimAssetImage.vue?vue&type=script&lang=js"

import "./ClaimAssetImage.vue?vue&type=style&index=0&id=28fd4b69&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fd4b69"]])

export default __exports__